import { useCallback, useState } from 'react'
import { datetimeFormatter } from 'transfix-ui'
import { IScraperJobConfigurationFragment } from '../graphql/ScraperJobConfigurationFragment'

interface IUseDisableAutobiddersMessage {
  updateScraperJobResults: IScraperJobConfigurationFragment[]
  configUpdatedAt: string | null
  message: string
  title: string
}

interface IDisableAutobiddersMessage {
  updateDisabledMessage: (updateScraperJobResults: any) => void
  disabledMessage: string
  disabledTitle: string
}

export const useDisableAutobiddersMessage = ({
  configUpdatedAt,
  message,
  title,
  updateScraperJobResults,
}: IUseDisableAutobiddersMessage) => {
  const [disabledMessage, setDisabledMessage] = useState<string>(message)
  const [disabledTitle, setDisabledTitle] = useState<string>(title)

  const updateDisabledMessage = useCallback(
    updateScraperJobResults => {
      const updatedConfig = updateScraperJobResults[0]
      if (updatedConfig && !updatedConfig?.isEnabled && configUpdatedAt) {
        const updatedBy = [
          updatedConfig.updatedBy.firstName,
          updatedConfig.updatedBy.lastName,
        ].join(' ')
        const updatedOn = datetimeFormatter({
          datetime: configUpdatedAt,
          displayTimezone: 'America/New_York',
          format: 'dateAndYearFullDateAlways',
        })
        const updatedReason = (updatedConfig.comment || '').split(',').join(', ')
        setDisabledTitle(`Disabled on ${updatedOn} by ${updatedBy}`)
        setDisabledMessage(updatedReason)
      } else {
        setDisabledTitle('')
        setDisabledMessage('')
      }
    },
    [updateScraperJobResults]
  )

  return { updateDisabledMessage, disabledMessage, disabledTitle } as IDisableAutobiddersMessage
}
